import { Apollo } from 'apollo-angular';
import * as fromGraphQl from './graphql';
import { Contact } from '../../shared/entities/contact/contact';
import { environment } from 'src/environments/environment';
import { ContactPerson } from '../../shared/entities/contactPerson/contactPerson';
import { NXDataSourcePrime } from '../../../core/services/dataSource/NXDataSourcePrime';

export class ContactPersonDataSource extends NXDataSourcePrime<Contact> {
  constructor(apollo: Apollo) {
    super(apollo, fromGraphQl.CONTACT_PERSON_LIST_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.ContactPersonListQueryResponse): void {
    super.setSubject(
      ContactPerson.createContactPersons(data.contactPersonList?.content),
      data.contactPersonList?.totalElements ? data.contactPersonList.totalElements : 0
    );
  }

  loadContactPersonList(variables: any): void {
    this.subscribeToQuery(variables);
  }
}
